
import { defineComponent } from "vue";
import CiButton from "@components/base/button.vue";
import InlineSvg from "vue-inline-svg";
import { UserProfileEmptyState } from "@pictograms";

export default defineComponent({
  name: "CiUsersProfileEmptyState",
  components: { "ci-button": CiButton, "inline-svg": InlineSvg },
  computed: {
    emptyStateIcon(): ImportedSVG {
      return UserProfileEmptyState;
    },
  },
});
